module.exports = __webpack_public_path__ + "img/rili1.e05e5709.png";